export function useCheckDuplicateEWBNumber() {
  const validatingEWBNumber = ref(false);
  const isDuplicateEWBNumber = ref(false);

  const { isDuplicate } = useEWayBillStore();
  const validateEWBNumber = async (payload) => {
    try {
      validatingEWBNumber.value = true;

      isDuplicateEWBNumber.value = false;

      await isDuplicate(payload);

      validatingEWBNumber.value = false;

      return true;
    } catch (error) {
      validatingEWBNumber.value = false;

      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        isDuplicateEWBNumber.value = true;

        return "EWay Bill  number already exists";
      }

      return true;
    }
  };

  return {
    isDuplicateEWBNumber,
    validatingEWBNumber,
    validateEWBNumber,
  };
}
